import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// redux
import { store } from './store'
import { Provider } from 'react-redux'
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { CssBaseline } from "@material-ui/core";
import { AppProvider } from './context/AppProvider';
import rg4js from 'raygun4js';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { selectCurrentToken, selectCurrentUser } from "./features/auth/authSlice";
import { loadUserProfile } from "./features/auth/authThunks";
import { SignalREncorehiveProvider } from "./context/signalREncorehive";
import { NotificationProvider } from "./context/NotificationContext";


LicenseInfo.setLicenseKey(
  "25c3b486f36f1fb03941230b97fbf02cTz0xMDk3NjYsRT0xNzczOTY0Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);
//A: material UI license key. The license key is designed to be public

rg4js('apiKey', window?.ENV?.VITE_RAYGUN_API_KEY || import.meta.env.VITE_RAYGUN_API_KEY);
rg4js('enableCrashReporting', true);
rg4js('enablePulse', true);
rg4js('enableRealUserMonitoring', true);
rg4js('options', {
  ignore3rdPartyErrors: true
});


const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#F29B1B",
      dark: "#F1950E",
      light: "#F3A634",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#FDE8A5",
      contrastText: "#fb8c00",
      light: "#FDE8A5",
      dark: "#FDE8A5",
    },
    background: {
      default: "#F2F2F2",
      paper: "#FFFFFF",
    },
    divider: "#FDE8A5",
    text: {
      primary: "#211714",
      secondary: "#F29B1B",
      hint: "#F29B1B",
      disabled: "#4F4F4F",
    },
    success: {
      main: "#64BC26",
      light: "#6AC728",
      dark: "#5AAA22",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#EA1601",
      light: "#FE210B",
      dark: "#D51401",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#ff9800",
      light: "#ff9800",
      dark: "#ff9800",
      contrastText: "#211714",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          borderRadius: "2em",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1rem'
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          maxHeight: '350px',
          overflowY: 'auto',
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {          
          borderRadius: "1em",
          backgroundColor: "white",
          padding: "0 1em",
          '& .MuiDataGrid-footerContainer': {
            minHeight: "32px",
          },
          '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
            fontSize:"13px",
            borderBottom: "1px solid #f2f2f2",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "10px",
            textTransform: "uppercase",
            fontWeight: "600",
            lineBreak: "auto",
            whiteSpace: "wrap",
            lineHeight: "1",
            textAlign: "center"
          },
          "& .MuiDataGrid-cell": {
            padding:'0 4px',
          }
        },
      }
    }
  },
});

const Root = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectCurrentToken);
  const user = useSelector(selectCurrentUser);


  React.useEffect(() => {
    console.log("authFlow, dispatching loadUserProfile?: " , (token && !user));
    if (token && !user) {
      console.log("authFlow, dispatching loadUserProfile...");
      dispatch(loadUserProfile());
    }
  }, [dispatch, token]);

  return <App />;
};

const container = document.getElementById("root");
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <CssBaseline />
      <Provider store={store}>
        <SignalREncorehiveProvider>
          <AppProvider>
            <NotificationProvider>
              <Root />
            </NotificationProvider>
          </AppProvider>
        </SignalREncorehiveProvider>
      </Provider>
    </React.StrictMode>
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
